import React from "react"
import { TapTag, StyledTaps, Container } from "./globalStyles"
import { Link } from "gatsby"
import "./project.css"
const Project = props => {
  return (
    <Container>
      <div id="box" className={props.imgClass}>
        <div id="content">
          {/* <img src={props.image} width="300px" height="300px" /> */}
          <h2>project</h2>
          <p>{props.explain}</p>
          <a
            id="link"
            href={props.site}
            target="_blank"
            style={{ background: props.bColor, color: props.textColor }}
          >
            {props.text}
          </a>
        </div>
      </div>
    </Container>
  )
}
export default Project
